import JSZip from 'jszip';
import preloadDocument from '@/helpers/preloadDocument';

const downloadFilesAsZip = async (
  documents: Array<{
    id: string;
    fileName: string;
  }>,
  accessToken: string,
  zipName: string,
): Promise<void> => {
  if (!documents || documents.length === 0) {
    console.warn('No documents to download.');
    return;
  }

  try {
    // Fetch each document as a blob
    const documentBlobs = await Promise.all(
      documents.map(async (doc) => {
        const blob = await preloadDocument({
          accessToken,
          id: doc.id,
        });
        return blob;
      }),
    );

    // Create a ZIP file
    const zip = new JSZip();
    documents.forEach((doc, index) => {
      zip.file(doc.fileName, documentBlobs[index]);
    });

    // Generate the ZIP and trigger download
    const zipBlob = await zip.generateAsync({ type: 'blob' });
    const zipUrl = URL.createObjectURL(zipBlob);
    const a = document.createElement('a');
    a.href = zipUrl;
    a.download = `${zipName}.zip`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(zipUrl);
  } catch (error) {
    console.error('Error downloading files as ZIP:', error);
  }
};

export default downloadFilesAsZip;
